import { useParams } from 'react-router-dom'
import { PaperPlaneTilt } from '@phosphor-icons/react'

import { ListWhen } from '@/main/features/List/components/ListWhen'
import { ItemTable } from '@/main/features/Item/components/ItemTable/ItemTable'
import { useAppSelector } from '@/main/app/hooks/storeHooks'
import { useList } from '@/main/features/List/hooks/useList'
import { useAppContext } from '@/main/app/context'
import { ListSummary } from '@/main/features/List/components/ListSummary/ListSummary'
import { Button } from '@/main/components/Button/Button'

export function CartIndex() {
  const { id } = useParams()
  const {
    formPaths: [step1, , step3],
  } = useAppContext()
  const list = useList(id)
  const isReady = useAppSelector((state) => state.app.isReady)

  return (
    <>
      <h2 className="twc-font-medium twc-text-2xl twc-mb-3">{list?.name ?? 'My Project'}</h2>

      <ListWhen isReady={isReady ?? false} isEmpty={!list?.itemIds || list.itemIds.length === 0}>
        {list && <ItemTable ids={list.itemIds} />}
      </ListWhen>

      <div className="twc-flex twc-flex-col twc-gap-4 twc-items-end twc-mx-2 twc-my-6 sm:twc-m-6">
        <div className="twc-w-full sm:twc-w-7/12 4xl:twc-w-5/12">
          <ListSummary listId={list?.id} />
        </div>

        {list?.history ? (
          <Button
            as="route"
            to={`/${list.id}/form/${step3}`}
            className="dark:twc-text-slate-50 dark:hover:twc-text-white"
          >
            Review and Submit Changes
            <PaperPlaneTilt />
          </Button>
        ) : (
          <Button
            as="route"
            to={list?.id ? `/${list.id}/form/${step1}` : ''}
            className="dark:twc-text-slate-50 dark:hover:twc-text-white"
          >
            Start New Request <PaperPlaneTilt />
          </Button>
        )}
      </div>
    </>
  )
}
